/*
  taroni-story.js
  Motion for sections/taroni-story.liquid.
  - The sticky photo, its keyword and the counter follow the chapter being read.
  - Desktop, with GSAP: crossfade + slow zoom of the photo, the keyword rises in,
    chapters not being read are dimmed while scrolling.
  - Mobile, with GSAP: the chapter photo opens (clip-path) as it enters.
  - Optional (data-words="true"): the opening sentence lights up word by word.
  - Opening (#ti-<section id>): the ochre rule draws once when it enters.
  Dimmed text stays readable: words start at 70% (5.1:1 on #faf6f1), dimmed
  paragraphs at 75% (5.2:1); eyebrows are never dimmed.
  Without GSAP, with prefers-reduced-motion or inside the theme editor the photo
  still changes, instantly, via IntersectionObserver; nothing is ever hidden.
*/
(function () {
  function setup(root) {
    if (root.dataset.tsReady) return;
    root.dataset.tsReady = '1';

    var imgs = root.querySelectorAll('.ts__img');
    var bigs = root.querySelectorAll('.ts__big');
    var num = root.querySelector('.ts__num');
    var chs = Array.prototype.slice.call(root.querySelectorAll('.ts__ch'));
    var cur = 0;
    var motion = !!(window.gsap && window.ScrollTrigger) &&
      !matchMedia('(prefers-reduced-motion: reduce)').matches &&
      !(window.Shopify && window.Shopify.designMode);

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function setChapter(i) {
      if (i === cur || !imgs[i]) return;
      var prev = cur;
      cur = i;
      if (num) num.textContent = pad(i + 1);
      if (!motion) {
        imgs[prev].classList.remove('is-on'); imgs[i].classList.add('is-on');
        if (bigs[prev]) bigs[prev].classList.remove('is-on');
        if (bigs[i]) bigs[i].classList.add('is-on');
        return;
      }
      gsap.to(imgs[prev], { opacity: 0, duration: 0.9, ease: 'power2.out', overwrite: true });
      gsap.fromTo(imgs[i], { opacity: 0, scale: 1.06 }, { opacity: 1, scale: 1, duration: 1.3, ease: 'power2.out', overwrite: true });
      if (bigs[prev]) gsap.to(bigs[prev], { opacity: 0, duration: 0.4, overwrite: true });
      if (bigs[i]) gsap.fromTo(bigs[i], { opacity: 0, yPercent: 40 }, { opacity: 1, yPercent: 0, duration: 0.8, ease: 'power3.out', overwrite: true });
    }

    if (!motion) {
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) setChapter(chs.indexOf(e.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      chs.forEach(function (c) { io.observe(c); });
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });
    /* from here GSAP owns opacity: classes only set the no-JS first frame */
    gsap.set(imgs, { opacity: 0 }); if (imgs[0]) gsap.set(imgs[0], { opacity: 1 });
    gsap.set(bigs, { opacity: 0 }); if (bigs[0]) gsap.set(bigs[0], { opacity: 1 });

    var mm = gsap.matchMedia();
    mm.add('(min-width: 768px)', function () {
      chs.forEach(function (ch, i) {
        var body = ch.querySelector('.ts__body'), lead = ch.querySelector('.ts__lead');
        if (i > 0 && body) gsap.fromTo(body, { opacity: 0.75 }, { opacity: 1, ease: 'none', scrollTrigger: { trigger: ch, start: 'top 80%', end: 'top 45%', scrub: true } });
        if (i < chs.length - 1) gsap.to([lead, body].filter(Boolean), { opacity: 0.75, ease: 'none', immediateRender: false, scrollTrigger: { trigger: ch, start: 'bottom 50%', end: 'bottom 20%', scrub: true } });
        ScrollTrigger.create({ trigger: ch, start: 'top 55%', end: 'bottom 55%', onToggle: function (s) { if (s.isActive) setChapter(i); } });
      });
    });
    mm.add('(max-width: 767px)', function () {
      root.querySelectorAll('.ts__ch-img').forEach(function (im) {
        gsap.fromTo(im, { clipPath: 'inset(10% 8% 10% 8%)' }, { clipPath: 'inset(0% 0% 0% 0%)', ease: 'none',
          scrollTrigger: { trigger: im, start: 'top 92%', end: 'top 50%', scrub: true } });
      });
    });

    if (root.dataset.words === 'true') {
      root.querySelectorAll('.ts__lead').forEach(function (p) {
        var words = [];
        (function walk(node) {
          Array.prototype.slice.call(node.childNodes).forEach(function (n) {
            if (n.nodeType === 3) {
              var frag = document.createDocumentFragment();
              n.textContent.split(/(\s+)/).forEach(function (t) {
                if (!t) return;
                if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
                var s = document.createElement('span'); s.className = 'ts__w'; s.textContent = t;
                frag.appendChild(s); words.push(s);
              });
              n.parentNode.replaceChild(frag, n);
            } else if (n.nodeType === 1) {
              walk(n);
            }
          });
        })(p);
        gsap.fromTo(words, { opacity: 0.7 }, { opacity: 1, stagger: 0.08, ease: 'none',
          scrollTrigger: { trigger: p, start: 'top 85%', end: 'bottom 50%', scrub: 0.6 } });
      });
    }

    var intro = document.getElementById(root.id.replace(/^ts-/, 'ti-'));
    var rule = intro && intro.querySelector('.ti__rule');
    if (rule) gsap.fromTo(rule, { scaleY: 0 }, { scaleY: 1, duration: 0.7, ease: 'power2.out',
      scrollTrigger: { trigger: rule, start: 'top 85%', once: true } });

    /* images load lazily: recompute positions once they arrive */
    root.querySelectorAll('img').forEach(function (im) {
      if (!im.complete) im.addEventListener('load', function () { ScrollTrigger.refresh(); }, { once: true });
    });
  }

  function init() {
    document.querySelectorAll('[data-taroni-story]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
